// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4186e072","119":"334b95d6","126":"8c449d44","279":"2b789888","452":"a5a32ed2","777":"2d040521"}[chunkId] + ".chunk.js";
};